import { render, staticRenderFns } from "./PFilePreview.vue?vue&type=template&id=592a9c4d&"
import script from "./PFilePreview.vue?vue&type=script&lang=js&"
export * from "./PFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports